import { sortByTagThenByCost } from './rate-list/sort-by';

export const getAllRatesFromRateGroups = (rateGroups) => {
  return rateGroups.flatMap((rateGroup) => rateGroup.rates).sort(sortByTagThenByCost);
};
